import { Popconfirm, Space, Tag, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"
import styled from "styled-components"

export function getColumns(onEdit, onDelete) {
  return [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
    },
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name - b.name,
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description - b.description,
    },
    {
      title: "Включен",
      dataIndex: "isActive",
      key: "isActive",
      render: (text) => (
        <StyledTag color={text ? "rgb(56, 142, 60)" : "rgb(211, 47, 47)"}>
          {text ? "ДА" : "НЕТ"}
        </StyledTag>
      ),
    },
    {
      title: "Действует до",
      dataIndex: "activeUntil",
      key: "activeUntil",
      render: (text, record) => (
        <>
          {text
            ? <span>{text}</span>
            : <Muted>бессрочно</Muted>}
          {record.autoDisabledAt && (
            <Tooltip
              placement="top"
              title={`Награду выключила автоматика ${record.autoDisabledAt}: все квесты, за которые она давалась, закончились. Включить обратно можно вручную — больше система её не тронет.`}
            >
              <AutoHint>выключена автоматически</AutoHint>
            </Tooltip>
          )}
        </>
      ),
    },
    ...(onEdit || onDelete ? [{
      title: "Действие",
      key: "action",
      render: (_, record) => (
        <Space size="small">
          {onEdit && (
            <Tooltip placement="top" title="Редактировать" mouseLeaveDelay={0}>
              <Button size="small" type="link" onClick={() => onEdit(record.id)}>
                <PencilSvg />
              </Button>
            </Tooltip>
          )}
          {onDelete && (
            <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
              <Popconfirm
                placement="left"
                title="Действительно хотите удалить?"
                onConfirm={() => onDelete(record.id)}
                onCancel={stopPropagation}
              >
                <Button size="small" type="link" onClick={stopPropagation}>
                  <TrashSvg />
                </Button>
              </Popconfirm>
            </Tooltip>
          )}
        </Space>
      ),
    }] : []),
  ]
}

const stopPropagation = (e) => {
  e?.stopPropagation()
}

const Muted = styled.span`
  color: rgba(0, 0, 0, 0.45);
`

const AutoHint = styled.div`
  color: rgb(211, 47, 47);
  font-size: 12px;
  cursor: help;
`

const StyledTag = styled(Tag)`
  font-weight: 600;
  text-transform: uppercase;
`
